function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWoosmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "13.613 7.831 13.613 4.466 10.356 4.466 10.356 7.831 8.62 7.831 5.364 7.831 5.364 12.823 2 12.823 2 16.079 8.62 16.079 8.62 12.823 8.62 11.087 13.613 11.087 13.613 7.831",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.636 7.921 15.379 7.921 15.379 12.913 13.643 12.913 13.643 12.913 10.387 12.913 10.387 19.534 13.643 19.534 13.643 16.169 18.636 16.169 18.636 12.913 18.636 12.913 18.636 11.177 22 11.177 22 7.921 18.636 7.921",
    style: {
      fill: "#222221"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoosmap);
export default __webpack_public_path__ + "static/media/woosmap.17cad6fe7a654d61ca5609f30ffa90bf.svg";
export { ForwardRef as ReactComponent };